<template>
  <div class="visitor-layout">
    <div class="px-0 mx-0" id="nav">
      <Header />

      <main class="layout-main">

        <div class="layout-router-view">
          <router-view/>
        </div>

      </main>

    </div>
  </div>
</template>
<script>
import Header from '../../components/Header';
export default {
  components:{
    Header,
  },
};
</script>

<style lang="scss" scoped>
  .visitor-layout {
    height: 100%;
    background: $white;

    .layout-main {
      height: calc(100vh - 50px);
      display: flex;
    }
    .layout-router-view {
      width: 100%;
      overflow: scroll;
      padding: 15px 30px;
    }
  }
</style>
